var url = "186cc5a47954e31f5c1c1c0b087587a6.png";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;